// Mirrors backend UserReport::getRequiredParams / DirectorTemplateBuilder::resolveEventIdParams
// (www/common/models/UserReport.php, www/frontend/modules/report/templateBuilder/DirectorTemplateBuilder.php):
// walks every `event_id` key of a report's source_request and collects `:param` placeholders,
// so the report-builder editor can surface them and let an admin supply a preview value instead
// of the template call 500ing with "[TEMPLATE] Param not found".
function collectRequiredParams(node, found) {
    if (Array.isArray(node)) {
        node.forEach(item => collectRequiredParams(item, found))
        return
    }
    if (!node || typeof node !== 'object') return
    for (const [key, value] of Object.entries(node)) {
        if (key === 'event_id') {
            const items = Array.isArray(value) ? value : [value]
            items.forEach(item => {
                if (typeof item === 'string' && item.startsWith(':')) found.add(item.slice(1))
            })
        } else if (value && typeof value === 'object') {
            collectRequiredParams(value, found)
        }
    }
}

export function getRequiredParams(sourceRequest) {
    const found = new Set()
    collectRequiredParams(sourceRequest, found)
    return Array.from(found)
}

/**
 * True if `sourceRequest` references a `:param` placeholder that has no (non-empty) value in
 * `params` yet — e.g. still being typed in the report-builder's variable-name input, or typed
 * but not yet given a preview value in the Report Variables panel. Executing in this state
 * always 500s on the backend ("[TEMPLATE] Param not found"), so callers should skip the
 * request entirely instead of firing one per keystroke.
 */
export function hasUnresolvedRequiredParams(sourceRequest, params) {
    const required = getRequiredParams(sourceRequest)
    if (!required.length) return false
    const p = params || {}
    return required.some(name => {
        const val = p[':' + name]
        return val === undefined || val === null || val === '' || (Array.isArray(val) && val.length === 0)
    })
}
